var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuitoFeliz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.988 0C5.364 0 0 5.376 0 12C0 18.624 5.364 24 11.988 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 11.988 0ZM12 21.6C6.69602 21.6 2.40002 17.304 2.40002 12C2.40002 6.69596 6.69602 2.39996 12 2.39996C17.304 2.39996 21.6 6.69596 21.6 12C21.6 17.304 17.304 21.6 12 21.6ZM18 9.00007C18 9.99607 17.196 10.8001 16.2 10.8001C15.204 10.8001 14.4 9.99607 14.4 9.00007C14.4 8.00407 15.204 7.20007 16.2 7.20007C17.196 7.20007 18 8.00407 18 9.00007ZM7.8 10.8001C8.796 10.8001 9.6 9.99607 9.6 9.00007C9.6 8.00407 8.796 7.20007 7.8 7.20007C6.804 7.20007 6 8.00407 6 9.00007C6 9.99607 6.804 10.8001 7.8 10.8001ZM17.7 15.3C16.56 17.268 14.436 18.6 12 18.6C9.56398 18.6 7.43998 17.268 6.29998 15.3C6.07198 14.904 6.37198 14.4 6.82798 14.4H17.172C17.64 14.4 17.928 14.904 17.7 15.3Z",
    fill: "#23A757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuitoFeliz);
export default __webpack_public_path__ + "static/media/MuitoFeliz.fe42bf3bb7d06878ae58ab73577c1eb3.svg";
export { ForwardRef as ReactComponent };